/**
 * Taken from https://github.com/mu29/react-stepper
 * This repo is archived and has out of date dependencies
 */
import React from 'react';
import { PropTypes } from 'prop-types';

import Step from './Step';

const Stepper = ({ activeStep = 0, steps }) => (
  <div className="w-100 p-0">
    <div className="d-table w-100">
      {steps.map((step, index) => {
        // Count from 1 for steps
        const modifiedIndex = index + 1;
        return (
          <Step
            key={modifiedIndex}
            width={100 / steps.length}
            title={step.title}
            active={modifiedIndex === activeStep}
            completed={modifiedIndex < activeStep}
            first={modifiedIndex === 1}
            isLast={modifiedIndex === steps.length}
            index={modifiedIndex}
          />
        );
      })}
    </div>
  </div>
);

Stepper.propTypes = {
  activeStep: PropTypes.number,
  steps: PropTypes.array
};

export default Stepper;
